import { render, staticRenderFns } from "./accruals.vue?vue&type=template&id=50f533ba&lang=true&"
import script from "./accruals.vue?vue&type=script&lang=js&"
export * from "./accruals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports